import * as z from 'zod';
import { DayJsSchema, DurationSchema } from './base-schemas';
import { dayjs, parseServerDate, parseServerDateTime } from '@/dayjs';
export const timeStringToDayJs = z.codec(z.string(), DayJsSchema, {
    encode: (dayJs) => dayJs.format('HH:mm:ss'),
    decode: (string) => dayjs(`1970-01-01T${string}`)
});
export const isoDateToDayJs = z.codec(z.iso.date(), DayJsSchema, {
    decode: (dateString) => {
        const date = parseServerDate(dateString);
        if (!date) {
            throw new Error(`Invalid date string: ${dateString}`);
        }
        return date;
    },
    encode: (date) => date.formatDateForServer()
});
/**
 * Accepts whatever can be parsed as a date by new Date()
 */
export const stringToDate = z.codec(z.string().refine(str => dayjs(str).isValid()), z.date(), {
    decode: (dateString) => new Date(dateString),
    encode: (date) => date.toISOString()
});
export const isoDateTimeToDayJs = z.codec(z.iso.datetime(), DayJsSchema, {
    decode: (isoString) => {
        const dayjs = parseServerDateTime(isoString);
        if (!dayjs) {
            throw new Error(`Invalid ISO datetime string: ${isoString}`);
        }
        return dayjs;
    },
    encode: (date) => date.toISOString()
});
export const stringToURL = z.codec(z.url(), z.instanceof(URL), {
    decode: (urlString) => new URL(urlString),
    encode: (url) => url.href
});
export const stringToDuration = z.codec(z.string(), DurationSchema, {
    decode: (durationString) => dayjs.duration(durationString),
    encode: (duration) => duration.toISOString()
});
export const minutesToDuration = z.codec(z.int().positive(), DurationSchema, {
    decode: minutes => dayjs.duration(minutes, 'minutes'),
    encode: duration => duration.asMinutes()
});
export const smallIntToBoolean = z.codec(z.union([z.literal(0), z.literal(1)], {
    error: 'Endast 1 eller 0 är tillåtet'
}), z.boolean(), {
    decode: int => int === 1,
    encode: boolean => boolean ? 1 : 0
});
export const stringToNumber = z.codec(z.string().regex(z.regexes.number), z.number(), {
    decode: str => Number.parseFloat(str),
    encode: num => num.toString()
});
